import React from 'react';
import { List, ListItemText, ListItemButton, CircularProgress, Alert, ListItemIcon, Tooltip, Typography, Collapse } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import { Client } from '../../models/core';


interface ClientListProps {
  selected?: string;
  clients: Client[];
  loading: boolean;
  collapsed?: boolean;
  error?: string | null;
}

const ClientList: React.FC<ClientListProps> = ({ selected, clients, loading, error, collapsed }) => {
  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">{error}</Alert>;

  // Determine visible clients
  const visibleClients = collapsed
    ? clients.filter((c) => c._id === selected)
    : clients;

  return (
    <List
      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
      component="nav"
      disablePadding
      aria-labelledby="nested-list-subheader"
    >
      {/* Keep animation for expand/collapse */}
      <Collapse in={!collapsed} timeout="auto" unmountOnExit>
        {!collapsed &&
          clients.map((client) => (
            <ListItemButton
              key={client._id}
              sx={{ height: '4em' }}
              component={RouterLink}
              to={`/v3/clients/${client._id}/dashboard`}
              selected={selected === client._id}
            >
              <ListItemIcon>
                <MedicalServicesOutlinedIcon/>
                </ListItemIcon>
              <ListItemText primary={<Tooltip title={client.name} >
                <Typography>{client.name}</Typography>
                </Tooltip>} primaryTypographyProps={{
                  sx: {
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  },
                }} />
            </ListItemButton>
          ))}
      </Collapse>

      {/* Render SINGLE ITEM when collapsed */}
      {collapsed && visibleClients.map((client) => (
        <ListItemButton
          key={client._id}
          sx={{ height: '4em' }}
          component={RouterLink}
          to={`/v3/clients/${client._id}/dashboard`}
          selected
        >
          <ListItemIcon><MedicalServicesOutlinedIcon /></ListItemIcon>
          <ListItemText
            primary={
              <Tooltip title={client.name}>
                <Typography>{client.name}</Typography>
              </Tooltip>
            }
          />
        </ListItemButton>
      ))}
    </List>
  );
};

export default ClientList;